import React, { memo, useState } from "react";
import { withStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";

import PatientOrganizationItem from "../patientOrganizationItem";
import PatientOrganizationItemHover from "../patientOrganizationItemHover";
import style from "../patientOrganizationItem/style.module.scss";
import { CompanyAvatar } from "../../../../primitives";

const width = window.innerWidth > 1200 ? 800 : 600;

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#fafafa",
    boxShadow: "5px 5px 4px 0 rgba(0, 0, 0, 0.14)",
    color: "rgba(0, 0, 0, 0.87)",
    width,
    minWidth: width,
    fontSize: theme.typography.pxToRem(15),
    border: "1px solid #cccccc",
    padding: "15px 20px 10px",
  },
}))(Tooltip);

const nameWrapperStyles = {
  cursor: "pointer",
  display: "flex",
  width: "180px",
  alignItems: "center",
};

const logoStyles = {
  minWidth: "24px",
  width: "24px",
  height: "24px",
  marginRight: "10px",
};

const CustomTooltipChild = React.forwardRef((props, ref) => {
  const {
    organization,
    history,
    dispatch,
    last,
    currentYear,
    handleRelationShipChange,
    selectModeIsActive,
    handleOrganizationSelect,
    isSelected,
    userIsScrolling,
    ...otherProps
  } = props;

  const handleCompanyClick = () => {
    history.push(`/patient_organizations/${organization.slug || organization.id}`);
  };

  return (
    <div
      {...otherProps}
      currentyear={currentYear}
      ref={ref}
      className={style.companyNameWrapper}
    >
      {selectModeIsActive && (
        <div className={style.selectCompany}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={handleOrganizationSelect}
          />
        </div>
      )}
      <div style={nameWrapperStyles} onClick={handleCompanyClick}>
        <div style={logoStyles}>
          <CompanyAvatar
            imgSrc={organization.logo}
            name={organization.name}
            hasBorderRadius
            smallSize
          />
        </div>
        <span>{organization.name}</span>
      </div>
    </div>
  );
});

const PatientOrganizationItemWrapper = (props) => {
  const {
    appReducer: { highlightItemWithId },
  } = useSelector((state) => state);
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`
      d-flex position-relative align-items-stretch ${
        props.last ? style.lastCompany : ""
      } 
      ${props.organization.id === highlightItemWithId ? style.flashingRow : ""}`}
      onMouseOut={() => setHovered(false)}
      onMouseLeave={() => setHovered(false)}
    >
      {/*<div onMouseOver={() => setHovered(true)} className="d-flex">*/}
      {/*  <HtmlTooltip*/}
      {/*    interactive*/}
      {/*    title={(*/}
      {/*      <>*/}
      {/*        <PatientOrganizationItemHover {...props} />*/}
      {/*      </>*/}
      {/*    )}*/}
      {/*    enterDelay={1000}*/}
      {/*    open={props.userIsScrolling ? false : hovered}*/}
      {/*    placement="top"*/}
      {/*  >*/}
      {/*    <CustomTooltipChild {...props} />*/}
      {/*  </HtmlTooltip>*/}
      {/*</div>*/}
      <CustomTooltipChild {...props} />
      <PatientOrganizationItem {...props} />
    </div>
  );
};

export default memo(PatientOrganizationItemWrapper);
